import { ref } from 'vue';
import categoryService from '@/services/categoryService';

export function useCategories(axios) {
  const categories = ref([]);
  const subcategory = ref();
  const brands = ref([]);
  const loading = ref(true);
  const error = ref(null);

  const category = ref([]);

  const fetchCategories = async (page = '') => {
    try {
      const { data } = await categoryService(axios).getCategories(page);
      console.log(data)
      categories.value = data;
    } catch (err) {
      error.value = 'Failed to load Categories';
    } finally {
      loading.value = false;
    }
  };
  const fetchHomeCategories = async (page = '') => {
    try {
      const { data } = await categoryService(axios).getHomeCategories(page);
      console.log(data)
      categories.value = data;
    } catch (err) {
      error.value = 'Failed to load Categories';
    } finally {
      loading.value = false;
    }
  };
  const fetchCategoryBySlug = async (slug) => {
    try {
      const {data} = await categoryService(axios).getCategoryBySlug(slug);
      // console.log(data)
      category.value = data;
    } catch (err) {
      error.value = 'Failed to load Category';
    } finally {
      loading.value = false;
    }
  };
  const fetchHomeSubcategoriesBySlug = async (slug) => {
    try {
      const {data} = await categoryService(axios).getHomeSubcategoriesBySlug(slug);
      // console.log(data)
      category.value = data;
    } catch (err) {
      error.value = 'Failed to load Category';
    } finally {
      loading.value = false;
    }
  };
  const fetchSubcategories = async (slug) => {
    try {
      const { data } = await categoryService(axios).getSubcategories(slug);
      // console.log(data)
      categories.value = data.subcategories;
    } catch (err) {
      error.value = 'Failed to load Subcategory';
    } finally {
      loading.value = false;
    }
  };
  const fetchBrands = async () => {
    try {
      const { data } = await categoryService(axios).getBrands();
      // console.log(data)
      brands.value = data;
    } catch (err) {
      error.value = 'Failed to load Brands';
    } finally {
      loading.value = false;
    }
  };

  return {
    category,
    categories,
    brands,
    loading,
    error,
    subcategory,
    fetchBrands,
    fetchCategories,
    fetchHomeSubcategoriesBySlug,
    fetchHomeCategories,
    fetchCategoryBySlug,
    fetchSubcategories
  };
}